export const musicPlatformConstants = {
	MusicPlatformSaveRequest: "MUSICPLATFORM_SAVE_STARTED",
	MusicPlatformSaveSuccess: "MUSICPLATFORM_SAVE_COMPLETED",
	MusicPlatformSaveFailure: "MUSICPLATFORM_SAVE_FAILED",

	MusicPlatformGetByfilterRequest: "MUSICPLATFORM_GET_BYFILTER_STARTED",
	MusicPlatformGetByfilterSuccess: "MUSICPLATFORM_GET_BYFILTER_COMPLETED",
	MusicPlatformGetByfilterFailure: "MUSICPLATFORM_GET_BYFILTER_FAILED",

	MusicPlatformDetailRequest: "MUSICPLATFORM_GET_DETAIL_STARTED",
	MusicPlatformDetailSuccess: "MUSICPLATFORM_GET_DETAIL_COMPLETED",
	MusicPlatformDetailFailure: "MUSICPLATFORM_GET_DETAIL_FAILED",

	MusicPlatformDeleteRequest: "MUSICPLATFORM_DELETE_STARTED",
	MusicPlatformDeleteSuccess: "MUSICPLATFORM_DELETE_COMPLETED",
	MusicPlatformDeleteFailure: "MUSICPLATFORM_DELETE_FAILED",
}